<template>
  <div class="container mx-auto">
    <el-dialog
      title="Nuevo puesto de trabajo"
      :visible.sync="showNewJobPosition"
      width="400px"
    >
      <el-form
        :model="newJobPositionForm"
        status-icon
        :rules="newJobPositionFormRules"
        ref="newJobPosition"
        @submit.native.prevent="
          submitNewJobPosition('newJobPosition', newJobPositionForm)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre del puesto" prop="name">
                  <el-input
                    placeholder="Nombre del puesto"
                    v-model="newJobPositionForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="12" class="flex flex-col justify-center">
                <el-form-item label="Código del puesto" prop="code">
                  <el-input
                    placeholder="Nombre del puesto"
                    v-model="newJobPositionForm.code"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" class="flex flex-col justify-center">
                <el-form-item label="¿Es tarea peligrosa?" prop="dangerousTask">
                  <el-radio-group v-model="newJobPositionForm.dangerousTask">
                    <el-row :gutter="15">
                      <el-col :span="12">
                        <el-radio
                          size="small"
                          class="w-full"
                          :label="true"
                          border
                        >
                          SI
                        </el-radio>
                      </el-col>
                      <el-col :span="12">
                        <el-radio
                          size="small"
                          class="w-full"
                          :label="false"
                          border
                        >
                          NO
                        </el-radio>
                      </el-col>
                    </el-row>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item
                  label="Descripción de funciones"
                  prop="description"
                >
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Funciones"
                    v-model="newJobPositionForm.description"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewJobPosition = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="Editar puesto de trabajo"
      :visible.sync="showEditJobPosition"
      width="350px"
    >
      <el-form
        :model="editJobPositionForm"
        status-icon
        :rules="editJobPositionFormRules"
        ref="editJobPosition"
        @submit.native.prevent="
          submitNewJobPosition(
            'editJobPosition',
            editJobPositionForm,
            editJobPositionForm.id
          )
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre del puesto" prop="name">
                  <el-input
                    placeholder="Nombre del puesto"
                    v-model="editJobPositionForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="12" class="flex flex-col justify-center">
                <el-form-item label="Codigo del puesto" prop="code">
                  <el-input
                    placeholder="Codigo del puesto"
                    v-model="editJobPositionForm.code"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" class="flex flex-col justify-center">
                <el-form-item label="¿Es tarea peligrosa?" prop="dangerousTask">
                  <el-radio-group v-model="editJobPositionForm.dangerousTask">
                    <el-row :gutter="15">
                      <el-col :span="12">
                        <el-radio
                          size="small"
                          class="w-full"
                          :label="true"
                          border
                        >
                          SI
                        </el-radio>
                      </el-col>
                      <el-col :span="12">
                        <el-radio
                          size="small"
                          class="w-full"
                          :label="false"
                          border
                        >
                          NO
                        </el-radio>
                      </el-col>
                    </el-row>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item
                  label="Descripción de funciones"
                  prop="description"
                >
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Funciones"
                    v-model="editJobPositionForm.description"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showEditJobPosition = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-row :gutter="15" type="flex" justify="start">
      <el-col :span="14">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">PUESTOS DE TRABAJO</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Aquí se administran los diferentes puestos de trabajo que se pueden asigar a cada empleado."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button
              type="primary"
              size="small"
              @click="openNewJobPositionDialog"
              >Nuevo puesto de trabajo</el-button
            >
          </el-col>
          <el-col :span="10">
            <el-input
              placeholder="Buscar"
              v-model="searchValue"
              size="small"
              suffix-icon="el-icon-search"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-table :data="filteredJobPositions" stripe size="mini">
          <el-table-column type="index" width="40" />
          <el-table-column prop="code" label="Cód. del puesto" width="120" />
          <el-table-column prop="name" label="Nombre del puesto" width="200" />
          <el-table-column
            prop="dangerousTask"
            label="¿Es tarea peligrosa?"
            width="140"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.dangerousTask ? "SI" : "NO" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="Funciones" width="300" />
          <el-table-column width="60" align="center">
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <el-button icon="el-icon-fa-ellipsis-v" size="small">
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="openEditJobPositionDialog(scope.row)"
                  >
                    <i class="el-icon-fa-pencil"></i> Editar información
                  </el-dropdown-item>
                  <el-dropdown-item
                    :divided="true"
                    class="text-red-500 font-semibold"
                    @click.native="deleteJobPosition(scope.row)"
                  >
                    <i class="el-icon-fa-trash"></i> Eliminar
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="rawJobPositions.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import * as V from "voca";

export default {
  name: "SettingsJobPositions",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{ jobPositions { id code name description dangerousTask } }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.jobPositions));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      rawJobPositions: [],
      searchValue: "",
      page: {
        size: 15,
        number: 1,
      },
      showNewJobPosition: false,
      newJobPositionForm: {
        code: "",
        name: "",
        dangerousTask: false,
        description: "",
      },
      newJobPositionFormRules: {
        code: [
          {
            required: true,
            message: "Por favor agrega el codigo.",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        dangerousTask: [
          {
            required: true,
            message: "Por seleccionar.",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Por favor agregar las funciones.",
            trigger: "blur",
          },
        ],
      },
      showEditJobPosition: false,
      editJobPositionForm: {
        code: "",
        name: "",
        dangerousTask: false,
        description: "",
      },
      editJobPositionFormRules: {
        code: [
          {
            required: true,
            message: "Por favor agrega el codigo.",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        dangerousTask: [
          {
            required: true,
            message: "Por seleccionar.",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Por favor agregar las funciones.",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    setData(data) {
      this.rawJobPositions = data;
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    deleteJobPosition({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar este puesto de trabajo?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { jobPositionDelete( where: {id: ${id}} ) { id code name description dangerousTask } }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawJobPositions = data.jobPositionDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado el puesto de trabajo correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    openNewJobPositionDialog() {
      const ref = this.$refs["newJobPosition"];
      if (!R.isNil(ref)) {
        ref.resetFields();
      }
      this.showNewJobPosition = true;
    },
    openEditJobPositionDialog({ id }) {
      axios
        .post("/", {
          query: `{ jobPosition(where: { id: ${id} }) { id code name dangerousTask description } }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.editJobPositionForm = data.jobPosition;
          }
          const ref = this.$refs["editJobPosition"];
          if (!R.isNil(ref)) {
            ref.resetFields();
          }
          this.showEditJobPosition = true;
        });
    },
    submitNewJobPosition(
      formName,
      { name, code, description, dangerousTask },
      jobPositionId = false
    ) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        const action = jobPositionId ? "editar" : "crear";
        const mutation = jobPositionId
          ? `jobPositionEdit(data: { name: "${name}", code: "${code}", dangerousTask: ${dangerousTask}, description: """${description}""" } where: { id: ${jobPositionId} } )`
          : `jobPositionCreate(data: { name: "${name}", code: "${code}", dangerousTask: ${dangerousTask}, description: """${description}""" } )`;
        this.$confirm(
          `¿Estás seguro que deseas ${action} este puesto de trabajo?`,
          "Confirmación",
          {
            confirmButtonText: `Si, ${action}`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation {
                      ${mutation}
                      { id code name dangerousTask description }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawJobPositions = jobPositionId
                        ? data.jobPositionEdit
                        : data.jobPositionCreate;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se ha creado el puesto de trabajo correctamente`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showNewJobPosition = false;
                    this.showEditJobPosition = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, ${action}`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
  },
  computed: {
    filteredJobPositions() {
      return this.rawJobPositions
        .filter((document) => {
          return (
            document.name
              .toLowerCase()
              .includes(this.searchValue.toLowerCase()) ||
            document.code.toLowerCase().includes(this.searchValue.toLowerCase())
          );
        })
        .slice(
          this.page.number * this.page.size - this.page.size,
          this.page.size * this.page.number
        );
    },
  },
};
</script>
